import React from 'react';
import { motion } from 'framer-motion';
import { BookTextIcon, ClapperboardIcon, LanguagesIcon, ScaleIcon, ScrollTextIcon, SearchCheckIcon } from 'lucide-react';
export function CostOfInaction() {
  const items = [['Narración cinematográfica', ClapperboardIcon], ['Basado en evidencia histórica', SearchCheckIcon], ['Diferencia hechos de teorías', ScaleIcon], ['Lenguaje claro', LanguagesIcon], ['Investigación rigurosa', ScrollTextIcon], ['Contenido exclusivo', BookTextIcon]];
  return <section className="bg-dark-card/45 px-5 py-24 md:py-32" data-id="element-41">
      <div className="mx-auto max-w-7xl" data-id="element-42">
        <div className="mb-14 text-center" data-id="element-43">
          <p className="text-xs font-bold uppercase tracking-[.22em] text-gold" data-id="element-44">
            El enfoque
          </p>
          <h2 className="mt-3 text-4xl font-semibold text-stone-light md:text-6xl" data-id="element-45">
            ¿Qué hace diferente esta colección?
          </h2>
        </div>
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-46">
          {items.map(([label, Icon], index) => <motion.div key={label as string} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="flex items-center gap-4 rounded-xl border border-dark-border bg-dark p-5" data-id="element-47">
              <Icon className="h-5 w-5 text-gold-light" data-id="element-48" />
              <span className="font-medium text-stone-light" data-id="element-49">{label}</span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}